/**
 *
 * @module mediaClientEndpoint
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef MediaClientEndpoint
 * @type {Object}
 *
 * @property {String} mediaPayload
 * @property {String} key
 * @property {String} playbackCookie
 *
 */

/**
 *
 * @enum
 * @type {MediaClientEndpoint}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    mediaPayload: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    key: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    playbackCookie: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    spriteSheetThumbnails: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    spriteSheetThumbnail: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    bifThumbnails: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    bifThumbnail: null
});



// WEBPACK FOOTER //
// ./src/services/media/mediaClientEndpoint.js